/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-extend-native */
// @ts-nocheck

import { PrismaClient } from '@prisma/client';

declare global {
  // allow global `var` declarations
  // eslint-disable-next-line no-var, vars-on-top
  var prisma: PrismaClient | undefined;
}

const prisma =
  global.prisma ||
  // Only generate prisma client on the backend, but still allow use of enums as values on the frontend
  // https://github.com/prisma/prisma/issues/3252#issuecomment-760364725
  (typeof window === 'undefined'
    ? new PrismaClient({
        log: ['info', 'warn', 'error'],
      })
    : undefined);

// https://github.com/GoogleChromeLabs/jsbi/issues/30#issuecomment-953187833
BigInt.prototype.toJSON = function () {
  return this.toString();
};

if (process.env.NODE_ENV !== 'production') global.prisma = prisma;

// To avoid 'object is possibly undefined' typescript errors when using this on the backend.
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export default prisma as PrismaClient;

// NOTE: Explicit mirrors of the e-signature status enums so their values are
// usable on the frontend regardless of the generated Prisma Client state.
// Values are the wire format of the backend's /docusign API responses — keep in
// sync with SignatureEnvelopeStatus / SignatureRecipientStatus in schema.prisma.
export const SignatureEnvelopeStatus = {
  CREATED: 'CREATED',
  SENT: 'SENT',
  DELIVERED: 'DELIVERED',
  COMPLETED: 'COMPLETED',
  DECLINED: 'DECLINED',
  VOIDED: 'VOIDED',
  FAILED: 'FAILED',
} as const;

export type SignatureEnvelopeStatus =
  (typeof SignatureEnvelopeStatus)[keyof typeof SignatureEnvelopeStatus];

export const SignatureRecipientStatus = {
  PENDING: 'PENDING',
  SENT: 'SENT',
  DELIVERED: 'DELIVERED',
  SIGNED: 'SIGNED',
  DECLINED: 'DECLINED',
  FAILED: 'FAILED',
} as const;

export type SignatureRecipientStatus =
  (typeof SignatureRecipientStatus)[keyof typeof SignatureRecipientStatus];

export const SignatureTemplateStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED',
} as const;

export type SignatureTemplateStatus =
  (typeof SignatureTemplateStatus)[keyof typeof SignatureTemplateStatus];

export * from '@prisma/client';
